import ScrollMagic from 'scrollmagic'
import { controller, debug } from '../util/scrollmagic';
import 'debug.addIndicators';
import { TweenMax } from 'gsap';
import 'animation.gsap';
import 'jquery';

export default class StickyContent {
  constructor(options) {
    if(!options.element) {
      return
    }
    this.element = options.element;
    this.identifier = options.debugId;
    this.offset = options.offset ? options.offset : 0;
    this.triggerHook = options.triggerHook ? options.triggerHook : 0;
    this.section = options.section ? options.section : this._getSection(this.element);
    this.parentElement = $(options.element).parent();

    this.addFadeAnimation();
    this.addStickyAnimation();
    this.checkWidth()

    window.addEventListener("resize", this.checkWidth.bind(this));
  }

  addStickyAnimation() {
    this.stickyAnimation = new ScrollMagic.Scene({
      triggerElement: this.section,
      triggerHook: this.triggerHook,
      duration: function () {
        return this._getDistance(this.section, this.parentElement)
      }.bind(this),
      offset: - this.offset,
    })
      .setPin(this.element, { pushFollowers: false })
      .addTo(controller);

    if(debug) {
      this.stickyAnimation.addIndicators({ name: 'stick ' + this.identifier });
    }
  }

  addFadeAnimation() {
    const tween = TweenMax.to(this.element, 0.5, { opacity: 1 });

    this.fadeAnimation = new ScrollMagic.Scene({
      triggerElement: this.section,
      triggerHook: 1,
      duration: '90%',
    })
      .setTween(tween)
      .addTo(controller);

    if(debug) {
      this.fadeAnimation.addIndicators({ name: 'fade ' + this.identifier });
    }
  }

  checkWidth() {
    if(window.innerWidth < 1023 && this.stickyAnimation && this.fadeAnimation) {
      this.stickyAnimation.removePin();
      this.stickyAnimation.destroy(true);
      this.fadeAnimation.removeTween();
      this.fadeAnimation.destroy(true);
      this.stickyAnimation = null;
      this.fadeAnimation = null;
    } else if (window.innerWidth > 1023 && !this.stickyAnimation && !this.fadeAnimation) {
      this.addFadeAnimation();
      this.addStickyAnimation();
    }
  }


  // Privat functions
  _getSection(element) {
    const parentSections = $(element).parents('.vc_section');
    const parentRow = $(element).parents('.vc_row');

    return parentSections.length ? parentSections[0] : parentRow[0];
  }

  _getDistance(from, to) {
    const bottomOfFrom = $(from).offset().top + $(from).outerHeight(true);
    const bottomOfTo = $(to).offset().top + $(to).outerHeight(true);
    const distance = bottomOfFrom - bottomOfTo;
    return distance > 0 ? distance : 1;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/sticky-content.js